
const parseError = (error) => {
  let errorText;
  if (error.errors && error.errors[0].message.includes('->')) {
    errorText = error.errors[0].message.split('->')[1];
  } else if (error.errors && error.errors[0].message) {
    errorText = error.errors[0].message;
  } else {
    errorText = error;
  }
  return errorText;
}

export default parseError;
